import { useEffect, useRef } from "react";
import { functions, getMacoMatches, getProfile } from "../firebase";
import { httpsCallable } from "firebase/functions";
import { useHasRole } from "./useHasRole";

export const usePrefetchCaches = (database?: string) => {
  const hasPrefetched = useRef(false);
  const { hasRole } = useHasRole("compare");

  useEffect(() => {
    if (hasPrefetched.current) return;
    if (!database) return;

    hasPrefetched.current = true;

    // Warm getProfiles cache
    const getProfiles = httpsCallable(functions, "getProfiles");
    getProfiles({
      profiles: ["_"],
      database,
    }).catch(() => {});

    // Warm getProfile + getMacoMatches cache (only for compare role)
    if (hasRole) {
      const macoDb = database === "Fungi-SSP" ? "fungi-compare" : "all";

      getMacoMatches({
        masses: [{ mz: 1, int: 1 }],
        database: macoDb,
        minMatches: 5,
        limit: 10,
        ppm: 800,
        speciesQuery: [],
        familyQuery: [],
      }).catch(() => {});

      getProfile({
        profile: "_",
        database: macoDb,
      }).catch(() => {});
    }
  }, [database, hasRole]);
};
